var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.89,22.55l-1.78.9L21.88,23l-1.64-3.29L15.72,17H10.28L5.76,19.71,4.12,23l-.23.45-1.78-.9,2.13-4.26L9.72,15h6.56l5.48,3.29ZM4,6V4H6V2H4V0H2V2H0V4H2V6Zm3.49,4.86L7,10V4l.49-.86,5-3h1l5,3L19,4v6l-.49.86-5,3h-1ZM9,9.43l4,2.4,4-2.4V4.57l-4-2.4L9,4.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileAdd);
export default __webpack_public_path__ + "static/1787897133/media/icon-profile-add.47dbc9bf2d67a42a72850e404ba4a2e9.svg";
export { ForwardRef as ReactComponent };